export default __webpack_public_path__ + "static/FS2S-InHub-14-d778f4fa674ef331209ff8bfc18ee009.jpg";